import { render, staticRenderFns } from "./cardGeo.vue?vue&type=template&id=07bba2de&scoped=true&"
import script from "./cardGeo.vue?vue&type=script&lang=js&"
export * from "./cardGeo.vue?vue&type=script&lang=js&"
import style0 from "./cardGeo.vue?vue&type=style&index=0&id=07bba2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bba2de",
  null
  
)

component.options.__file = "cardGeo.vue"
export default component.exports